<ui-page-header
  [actionLink]="srmCreateLink()"
  actionIcon="plus"
  actionText="Neue Anfrage erstellen"
  subtitle="Ihre Anfragen und Reklamationen der letzten 3 Monate auf einen Blick."
>
  Anfragen & Reklamationen
</ui-page-header>

<div class="section-wrapper">
  @if (ticketsResource.isLoading()) {
    @if (isDesktop()) {
      <ui-srm-ticket-list-desktop-skeleton></ui-srm-ticket-list-desktop-skeleton>
    } @else {
      <ui-srm-ticket-list-mobile-skeleton></ui-srm-ticket-list-mobile-skeleton>
    }
  } @else if (ticketsResource.error()) {
    <ui-alert theme="error" message="Beim Laden der Anfragen und Reklamationen ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal."></ui-alert>
  } @else {
    @if (tickets().length) {
      @if (isDesktop()) {
        <ui-srm-ticket-list-desktop [tickets]="tickets()"></ui-srm-ticket-list-desktop>
      } @else {
        <ui-srm-ticket-list-mobile [tickets]="tickets()"></ui-srm-ticket-list-mobile>
      }
    } @else {
      <div class="no-results-container">
        <ui-icon faName="empty-set" faStyle="light"></ui-icon>
        <h2>Keine Anfragen oder Reklamationen</h2>
        <p>Zur Zeit liegen keine Anfragen oder Reklamationen vor.</p>
      </div>
    }
  }
</div>
